import { FunctionComponent, useCallback, useState } from "react";
import { TourList } from "../entities/shared/TourList/TourList";
import { Tabs, Tab } from "@ui-kit/Tabs/Tabs";
import { LocationLink } from "../entities/LocationLink/LocationLink";
import { Category } from "../entities/Category/Category";
import { AddRemoveButton } from "../components/buttons/AddRemoveButton/AddRemoveButton";
import { ShareEntityButton } from "../components/buttons/ShareEntityButton/ShareEntityButton";
import { EntityBackButton } from "../components/buttons/EntityBackButton/EntityBackButton";
import { Place } from "@dto/Place";
import { PlaceActionButtons } from "./PlaceActionButtons";
import { parseEntityDescription } from "@lib/parseEntityDescription";
import { AudioPlayerButton } from "../media/AudioPlayer/AudioPlayerButton";

import "./PlaceView.css";
import { VideoPlayerButton } from "../media/VideoPlayer/VideoPlayerButton";
import { ListingValue } from "@modules/entities/ListingValue/ListingValue";

const getTabs = (place: Place) => {
  const tabs = [{ label: "Details", key: "details" }];

  if (place.tourIds?.length > 0) {
    tabs.splice(1, 0, { label: "Tours", key: "tours" });
  }

  return tabs;
};

interface PlaceViewProps {
  place: Place;
}

const PlaceView: FunctionComponent<PlaceViewProps> = ({ place }) => {
  const [activeTab, setActiveTab] = useState("details");

  const handleTabPress = useCallback((tab: Tab) => {
    setActiveTab(tab.key);
  }, []);

  return (
    <div className="place-container">
      <div
        className="cover-photo"
        style={{
          backgroundImage: `url(${place.coverPhotoUrl})`,
          height: "228px",
        }}>
        <div className="gradient"></div>
        <div className="cover-actions">
          <div className="cover-actions-top">
            <div className="cover-actions-top-left">
              <EntityBackButton />
            </div>
            <div className="cover-actions-top-right">
              <AddRemoveButton id={place.id} type="Place" />
              <ShareEntityButton entity={place} />
            </div>
            <div className="video-player-button-container">
              <VideoPlayerButton entity={place} />
            </div>
          </div>
        </div>
      </div>

      <div className="header">
        <span className="header-title">{place.name}</span>

        <AudioPlayerButton entity={place} />
      </div>

      <div className="secondary-items-container">
        <Category entity={place} />
        <ListingValue entity={place} />
      </div>

      <div className="actions">
        <PlaceActionButtons place={place} />
      </div>

      <div className="tabs">
        <Tabs
          tabs={getTabs(place)}
          defaultTabValue={activeTab}
          onTabChange={handleTabPress}
        />
      </div>
      <div className="tab-content">
        {activeTab === "details" && (
          <>
            <LocationLink entity={place} />
            <div
              dangerouslySetInnerHTML={{
                __html: parseEntityDescription(place.description),
              }}
              data-testid="entity-description"
              className="place-description-container"></div>
          </>
        )}
        {activeTab === "tours" && <TourList id={place.id} type={"Place"} />}
      </div>
    </div>
  );
};

export { PlaceView };
